// src/components/FitText/FitText.tsx
import React, {
  FC, HTMLAttributes, useLayoutEffect, useRef,
} from 'react';

// Karta z napisem w ramce o stałej wielkości (np. karta ze słowem w grach). Zwrot, który się w niej nie mieści,
// dostaje mniejszą czcionkę — po pół piksela, aż się zmieści albo dojdzie do najmniejszej. Największa czcionka to
// font-size karty z arkusza stylów, najmniejszą podaje ten sam arkusz w zmiennej --fit-text-min (dziś tylko na telefonie:
// .kiddo-phone-card-text() w src/views/kiddo-games/palette.less dla gier Easy i .games-phone-card-text()
// w src/styles/gamesPhone.less dla gier Regular). Bez tej zmiennej napis zostaje taki, jak w arkuszu. Poza tym zwykły div
export const FitText: FC<HTMLAttributes<HTMLDivElement>> = ({ children, ...props }) => {
  const ref = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    const element = ref.current;

    if (!element) return undefined;

    const overflows = () => element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;

    const fit = () => {
      // Bez animacji zmiany wielkości (karty mają transition: all) — pomiar widziałby jeszcze poprzednią czcionkę
      element.style.transition = 'none';
      element.style.fontSize = '';

      const style = getComputedStyle(element);
      const min = parseFloat(style.getPropertyValue('--fit-text-min'));
      let size = parseFloat(style.fontSize);

      // Pomiar (overflows) wypada zawsze po ostatniej zmianie czcionki, więc animacja wraca już po niej
      while (!Number.isNaN(min) && overflows() && size > min) {
        size = Math.max(min, size - 0.5);
        element.style.fontSize = `${size}px`;
      }

      element.style.transition = '';
    };

    fit();
    // Obrót telefonu albo zmiana okna zmienia wielkość karty
    window.addEventListener('resize', fit);

    return () => window.removeEventListener('resize', fit);
  }, [children]);

  return (
    <div ref={ref} {...props}>
      {children}
    </div>
  );
};

export default FitText;
